export const visit = (vm, at) => {
vm(require("./custom-views-build/en.lyaml"));
vm(require("./view-members/en.lyaml"));
vm(require("./visitors/en.lyaml"));
at({ "en": { "placeholderKey": "" } });
};